import { jsx } from "panel";
export function template() {
  const {
    visibility
  } = this.state;
  const direction = this.attr("direction");
  return /* @__PURE__ */ jsx("div", { sel: ".mp-drop-menu-body", attrs: {
    elref: "contentBody"
  }, class: {
    ["is-direction-".concat(direction)]: true,
    ["is-".concat(visibility)]: true
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("slot", { on: {
    close: (ev) => {
      ev.stopPropagation();
      this.close();
    }
  }, "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }), this.attr("show-arrow") && /* @__PURE__ */ jsx("div", { sel: ".mp-drop-menu-arrow" }));
}
